import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layouts/default-layout/default-layout.component';
import { AuthGuardService } from './shared/auth-guard.service';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { UpSessionComponent } from '@done/ngx-essentials';
import { LOGIN_ROUTE } from './shared/login-route.constant';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { 
        path: '', 
        loadChildren: () => import('./features/time-sheets/time-sheet.module').then(m => m.TimeSheetModule),
        canActivate: [AuthGuardService],
      },

      { path: 'help', loadChildren: () => import('./features/help/help.module').then(m => m.HelpModule) },
      {
        path: 'monthly-closings',
        loadChildren: () => import('./features/monthly-closings/monthly-closing.module').then(m => m.MonthlyClosingModule),
        canActivate: [AuthGuardService],
        data: { role: 'Admin' },
      },
      {
        path: 'tenants-groups',
        loadChildren: () => import('./features/tenants-groups/tenant-group.module').then(m => m.TenantGroupModule),
        canActivate: [AuthGuardService],
        data: { role: 'Admin' },
      },
      {
        path: 'tenants',
        loadChildren: () => import('./features/tenants/tenant.module').then(m => m.TenantModule),
        canActivate: [AuthGuardService],
        data: { role: 'Admin' },
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users-roles/user-role.module').then(m => m.UserRoleModule),
        canActivate: [AuthGuardService],
        data: { role: 'Admin' },
      },
    ],
    canActivate: [
      AuthGuardService
    ]
  },

  { path: LOGIN_ROUTE, component: LoginLayoutComponent },
  { path: 'session', component: UpSessionComponent },

  { path: '**', redirectTo: '/', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
